export default __webpack_public_path__ + "static/jasper-ef5efd0e8836c83681f858c304a4bf7a.jpg";